import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Analyzer } from 'types';

interface Props {
  analyzers: Analyzer[] | undefined;
  selectedAnalyzerId: number | null;
  fullWidth?: boolean;
  disabled?: boolean;
  handleAnalyzerChanged: (...args: any[]) => void;
  error?: boolean;
  required?: boolean;
}

const AnalyzerSelectLocal = ({
  analyzers,
  selectedAnalyzerId,
  handleAnalyzerChanged,
  fullWidth = false,
  disabled = false,
  error = false,
  required = false,
}: Props) => {
  return (
    <FormControl variant='outlined' fullWidth={fullWidth}>
      <InputLabel required={required} id='analyzer-select-label'>
        Analyzer
      </InputLabel>
      <Select
        labelId='analyzer-select-label'
        id='analyzer-select'
        name='analyzer'
        label='Analyzer'
        value={selectedAnalyzerId === null ? undefined : selectedAnalyzerId}
        onChange={handleAnalyzerChanged}
        placeholder='None'
        disabled={disabled}
        error={error}
      >
        <MenuItem value={-1}>
          <em>None</em>
        </MenuItem>
        {analyzers?.map((analyzer) => {
          return (
            <MenuItem key={analyzer.id} value={analyzer.id}>
              {analyzer.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default AnalyzerSelectLocal;
